import { GET_ORDER_REVIEW_RESPONSE } from "./actionTypes";

import produce from "immer";

export const initialState = {
  orderReviewRecord: null,
};

const orderReview = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_ORDER_REVIEW_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.orderReviewRecord = response.responseData;
        } else {
          draft.orderReviewRecord = null;
        }
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default orderReview;
